<template>
  <div class="container-grid__item">
    <div class="doc" :class="cssClass">
      <div class="doc__content row">
        <div class="col-auto text-center">
          <div class="ext-wrapper m-0">
            <img src="/pic/icon-doc.svg"/>
          </div>
        </div>
        <div class="col">
          <div class="doc__title" v-html="title"></div>
        </div>
      </div>
      <div class="doc__actions">
        <a :href="link" target="_blank" class="btn btn-outline-primary btn-outline-primary-with-icon d-flex justify-content-between mb-0 btn-label">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.52667 8.86016C5.46418 8.92214 5.41459 8.99587 5.38074 9.07711C5.34689 9.15835 5.32947 9.24549 5.32947 9.3335C5.32947 9.4215 5.34689 9.50864 5.38074 9.58988C5.41459 9.67112 5.46418 9.74485 5.52667 9.80683L7.52667 11.8068C7.58864 11.8693 7.66238 11.9189 7.74362 11.9528C7.82486 11.9866 7.91199 12.004 8 12.004C8.08801 12.004 8.17515 11.9866 8.25638 11.9528C8.33762 11.9189 8.41136 11.8693 8.47333 11.8068L10.4733 9.80683C10.5989 9.68129 10.6694 9.51103 10.6694 9.3335C10.6694 9.15596 10.5989 8.9857 10.4733 8.86016C10.3478 8.73463 10.1775 8.6641 10 8.6641C9.82247 8.6641 9.6522 8.73463 9.52667 8.86016L8.66667 9.72683V2.00016C8.66667 1.82335 8.59643 1.65378 8.4714 1.52876C8.34638 1.40373 8.17681 1.3335 8 1.3335C7.82319 1.3335 7.65362 1.40373 7.5286 1.52876C7.40357 1.65378 7.33333 1.82335 7.33333 2.00016V9.72683L6.47333 8.86016C6.41136 8.79768 6.33762 8.74808 6.25638 8.71424C6.17515 8.68039 6.08801 8.66296 6 8.66296C5.91199 8.66296 5.82486 8.68039 5.74362 8.71424C5.66238 8.74808 5.58864 8.79768 5.52667 8.86016ZM12 6.00016H10.6667C10.4899 6.00016 10.3203 6.0704 10.1953 6.19543C10.0702 6.32045 10 6.49002 10 6.66683C10 6.84364 10.0702 7.01321 10.1953 7.13823C10.3203 7.26326 10.4899 7.3335 10.6667 7.3335H12C12.1768 7.3335 12.3464 7.40373 12.4714 7.52876C12.5964 7.65378 12.6667 7.82335 12.6667 8.00016V12.6668C12.6667 12.8436 12.5964 13.0132 12.4714 13.1382C12.3464 13.2633 12.1768 13.3335 12 13.3335H4C3.82319 13.3335 3.65362 13.2633 3.5286 13.1382C3.40357 13.0132 3.33333 12.8436 3.33333 12.6668V8.00016C3.33333 7.82335 3.40357 7.65378 3.5286 7.52876C3.65362 7.40373 3.82319 7.3335 4 7.3335H5.33333C5.51014 7.3335 5.67971 7.26326 5.80474 7.13823C5.92976 7.01321 6 6.84364 6 6.66683C6 6.49002 5.92976 6.32045 5.80474 6.19543C5.67971 6.0704 5.51014 6.00016 5.33333 6.00016H4C3.46957 6.00016 2.96086 6.21088 2.58579 6.58595C2.21071 6.96102 2 7.46973 2 8.00016V12.6668C2 13.1973 2.21071 13.706 2.58579 14.081C2.96086 14.4561 3.46957 14.6668 4 14.6668H12C12.5304 14.6668 13.0391 14.4561 13.4142 14.081C13.7893 13.706 14 13.1973 14 12.6668V8.00016C14 7.46973 13.7893 6.96102 13.4142 6.58595C13.0391 6.21088 12.5304 6.00016 12 6.00016Z"/>
          </svg>
          Скачать
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Document",
  props: {
    link: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      default() {
        return 'p-24 container-shadow fill-white'
      }
    }
  }
}
</script>

<style scoped>

</style>